import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';

import {fadeIn} from "../../../animations/animations";

@Component({
    selector: 'app-display-message',
    templateUrl: './display-message.component.html',
    styleUrls: ['./display-message.component.scss'],
    animations: [fadeIn],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatIconModule, MatButtonModule]
})
export class DisplayMessageComponent {

  @Input() message: string = '';
  @Input() visible: boolean = false;
  @Input() type: 'success' | 'error' | 'warning' | 'info' = 'success';
  @Output() private visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();


  close() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }
}
